
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8Ug8x", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $67c012166b43ab0c$export$6503ec6e8aabbaf; }, function (v) { return $67c012166b43ab0c$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $67c012166b43ab0c$export$f7ad0328861e2f03; }, function (v) { return $67c012166b43ab0c$export$f7ad0328861e2f03 = v; });
var $67c012166b43ab0c$export$6503ec6e8aabbaf;
var $67c012166b43ab0c$export$f7ad0328861e2f03;
"use strict";
var $67c012166b43ab0c$var$mapping = new Map();
function $67c012166b43ab0c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$67c012166b43ab0c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $67c012166b43ab0c$var$resolve(id) {
    var resolved = $67c012166b43ab0c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$67c012166b43ab0c$export$6503ec6e8aabbaf = $67c012166b43ab0c$var$register;
$67c012166b43ab0c$export$f7ad0328861e2f03 = $67c012166b43ab0c$var$resolve;

});

parcelRegister("92HC5", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $695621aa74b73e2a$export$bdfd709ae4826697; }, function (v) { return $695621aa74b73e2a$export$bdfd709ae4826697 = v; });
var $695621aa74b73e2a$export$bdfd709ae4826697;
var $695621aa74b73e2a$export$c9e73fbda7da57b6;
var $695621aa74b73e2a$export$5a759dc7a1cfb72a;
"use strict";
var $695621aa74b73e2a$var$bundleURL = {};
function $695621aa74b73e2a$var$getBundleURLCached(id) {
    var value = $695621aa74b73e2a$var$bundleURL[id];
    if (!value) {
        value = $695621aa74b73e2a$var$getBundleURL();
        $695621aa74b73e2a$var$bundleURL[id] = value;
    }
    return value;
}
function $695621aa74b73e2a$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $695621aa74b73e2a$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $695621aa74b73e2a$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $695621aa74b73e2a$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$695621aa74b73e2a$export$bdfd709ae4826697 = $695621aa74b73e2a$var$getBundleURLCached;
$695621aa74b73e2a$export$c9e73fbda7da57b6 = $695621aa74b73e2a$var$getBaseURL;
$695621aa74b73e2a$export$5a759dc7a1cfb72a = $695621aa74b73e2a$var$getOrigin;

});

parcelRegister("jTGeK", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("dmJk3")).then(()=>parcelRequire("eCg4q"));

});
parcelRegister("jmEuB", function(module, exports) {
"use strict";

var $epnDT = parcelRequire("epnDT");
module.exports = $epnDT(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("epnDT", function(module, exports) {
"use strict";
var $a7d5bd68ac71a390$var$cachedBundles = {};
var $a7d5bd68ac71a390$var$cachedPreloads = {};
var $a7d5bd68ac71a390$var$cachedPrefetches = {};
function $a7d5bd68ac71a390$var$getCache(type) {
    switch(type){
        case "preload":
            return $a7d5bd68ac71a390$var$cachedPreloads;
        case "prefetch":
            return $a7d5bd68ac71a390$var$cachedPrefetches;
        default:
            return $a7d5bd68ac71a390$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a7d5bd68ac71a390$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("hPCF3", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("hMKCS")).then(()=>parcelRequire("c6z2K"));

});

parcelRegister("3altD", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("5BQ10")).then(()=>parcelRequire("e8y07"));

});

parcelRegister("hL0WE", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("iwOZA")).then(()=>parcelRequire("9Vfaw"));

});

parcelRegister("eEJZE", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("dNaE1")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("23zpV"))
]).then(()=>parcelRequire("kXac5"));

});

parcelRegister("h1LnJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("dNaE1")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("178jE"))
]).then(()=>parcelRequire("6wxEl"));

});

parcelRegister("i5JLD", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9O12P")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("jrb3C"))
]).then(()=>parcelRequire("iskSB"));

});

parcelRegister("03d8T", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9O12P")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4EyUB"))
]).then(()=>parcelRequire("1mAy2"));

});

parcelRegister("gtZf8", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("9O12P")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("nLHoS"))
]).then(()=>parcelRequire("d5hG9"));

});

parcelRegister("6KZQJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("gXq7s"))
]).then(()=>parcelRequire("d7nkV"));

});

parcelRegister("8Lo3g", function(module, exports) {


module.exports = (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("7jKNu")).then(()=>parcelRequire("ihlM2"));

});

parcelRegister("3H8Zn", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("8oqvn"))
]).then(()=>parcelRequire("1qPDV"));

});

parcelRegister("3HkUJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("4PHEE")),
    (parcelRequire("jmEuB"))((parcelRequire("8Ug8x")).resolve("6VIns"))
]).then(()=>parcelRequire("92a7f"));

});

var $771dc42295bfdc40$exports = {};


(parcelRequire("8Ug8x")).register((parcelRequire("92HC5")).getBundleURL("g63Tr"), JSON.parse('["g63Tr","as-modern.js","dmJk3","animLayer.module.fe0916c2.js","hMKCS","formHeaderSearch.module.dbd797e8.js","5BQ10","header.module.7eef1267.js","iwOZA","mainNav.module.037d780c.js","23zpV","modal.module.c4483957.js","dNaE1","modal.module.643073d0.js","178jE","panel.module.f3d560b6.js","jrb3C","swiper1.module.3e62aa1a.js","9O12P","swiper1.module.08d47896.js","4EyUB","swiper2.module.35fb9de7.js","nLHoS","swiper3.module.67d500a0.js","gXq7s","magnificPopup.module.59309a02.js","4PHEE","magnificPopup.module.ac496ba4.js","7jKNu","quoteSlider.module.658ce684.js","8oqvn","asVideo.module.f72b945d.js","6VIns","ceClinicsCenters.module.e15f4bb0.js"]'));

"use strict";
function $25865e9d3dfe9009$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $25865e9d3dfe9009$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $25865e9d3dfe9009$var$_typeof(o);
}
function $25865e9d3dfe9009$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($25865e9d3dfe9009$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $25865e9d3dfe9009$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $25865e9d3dfe9009$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $25865e9d3dfe9009$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}

if (document.querySelector(".teaser .teaser__anim-layer")) Promise.resolve().then(function() {
    return (parcelRequire("jTGeK"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".form-header-search")) Promise.resolve().then(function() {
    return (parcelRequire("hPCF3"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".header")) Promise.resolve().then(function() {
    return (parcelRequire("3altD"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".main-nav")) Promise.resolve().then(function() {
    return (parcelRequire("hL0WE"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".modal")) Promise.resolve().then(function() {
    return (parcelRequire("eEJZE"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".panel")) Promise.resolve().then(function() {
    return (parcelRequire("h1LnJ"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container--1")) Promise.resolve().then(function() {
    return (parcelRequire("i5JLD"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container--2")) Promise.resolve().then(function() {
    return (parcelRequire("03d8T"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".swiper-container--3")) Promise.resolve().then(function() {
    return (parcelRequire("gtZf8"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".lightbox")) Promise.resolve().then(function() {
    return (parcelRequire("6KZQJ"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".ctype-ce_quote_slider")) Promise.resolve().then(function() {
    return (parcelRequire("8Lo3g"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".js-player")) Promise.resolve().then(function() {
    return (parcelRequire("3H8Zn"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});

if (document.querySelector(".page-clinics-and-centers")) Promise.resolve().then(function() {
    return (parcelRequire("3HkUJ"));
}).then(function(res) {
    return $25865e9d3dfe9009$var$_interopRequireWildcard(res);
}).then(function(module) {
    module.init();
});
 // const whenComplete = () => {
 //   if (document.readyState === "complete") {
 //     // Resize
 //     let prevScreenWidth = window.innerWidth;
 //     window.addEventListener("resize", function (e) {
 //       if (!e.isTrigger) {
 //         clearTimeout(this._timer);
 //         this._timer = setTimeout(() => {
 //           if (Math.abs(window.innerWidth - prevScreenWidth) < 99) {
 //             // Prevent from further operations for Google mobile browsers
 //             // (if event is not real screen change of a device)
 //             return;
 //           }
 //           prevScreenWidth = window.innerWidth;
 //           console.log(
 //             "%cMain resize",
 //             "color:#6f6f6f;font-family:monospace;font-size:12px;"
 //           );
 //         }, 400);
 //       }
 //     });
 //   } else {
 //     setTimeout(function () {
 //       whenComplete();
 //     }, 400);
 //   }
 // };
 // whenComplete();
 // let styleAttempts = 0;
 // const stylesComplete = () => {
 //   if (styleAttempts > 30) return;
 //   styleAttempts += 1;
 //   if (document.getElementById("spreld").getAttribute("rel") === "stylesheet") {
 //     document.getElementById("sess").remove();
 //   } else {
 //     setTimeout(function () {
 //       stylesComplete();
 //     }, 300);
 //   }
 // };
 // stylesComplete();


//# sourceMappingURL=as-modern.js.map
